import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

export const TermsPage = () => {
  return (
    <div className="pt-24 pb-16" data-testid="terms-page">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="glass-card p-8 md:p-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Terms of Service</h1>
          <p className="text-white/50 mb-8">Last updated: January 2024</p>

          <div className="prose prose-invert max-w-none">
            <div className="space-y-8 text-white/70">
              <section>
                <h2 className="text-xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
                <p>
                  By accessing or using Cost Genie's services, you agree to be bound by these Terms of Service 
                  and all applicable laws and regulations. If you do not agree with any of these terms, you 
                  are prohibited from using or accessing this service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">2. Description of Service</h2>
                <p>
                  Cost Genie provides an AI-powered Quote-to-SOP platform for manufacturing suppliers. Our 
                  services include RFQ management, BOM management, costing automation, workflow approvals, 
                  and analytics dashboards.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">3. User Accounts</h2>
                <p>
                  You are responsible for maintaining the confidentiality of your account credentials and for 
                  all activities that occur under your account. You must notify us immediately of any 
                  unauthorized use of your account.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">4. Subscription and Payment</h2>
                <p>
                  Subscription fees are billed in advance on a monthly or annual basis. All fees are 
                  non-refundable except as expressly set forth in these Terms. We reserve the right to 
                  change our pricing with 30 days notice.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">5. Data and Privacy</h2>
                <p>
                  Your use of the service is also governed by our Privacy Policy. You retain all rights to 
                  your data. We will not access, use, or share your data except as necessary to provide the 
                  service or as required by law.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">6. Intellectual Property</h2>
                <p>
                  The service and its original content, features, and functionality are owned by Cost Genie 
                  and are protected by international copyright, trademark, patent, trade secret, and other 
                  intellectual property laws.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">7. Limitation of Liability</h2>
                <p>
                  Cost Genie shall not be liable for any indirect, incidental, special, consequential, or 
                  punitive damages resulting from your use of or inability to use the service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">8. Termination</h2>
                <p>
                  We may terminate or suspend your account and access to the service immediately, without 
                  prior notice or liability, for any reason, including breach of these Terms.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-4">9. Contact Information</h2>
                <p>
                  For any questions about these Terms, please contact us at:{' '}
                  <a href="mailto:info@costgenie.com" className="text-[#00D4FF] hover:underline">
                    info@costgenie.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;
